// extracted by mini-css-extract-plugin
export default {"boardGrid":"TrackerBoardView_boardGrid__jjjcB"};